import { Cookies } from 'react-cookie';

import { UserCreateFormValues } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export interface createUserPageDataProps {
  userData: UserCreateFormValues;
}

export const createUserPageData = async (info: createUserPageDataProps) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.post(
    '/users/',
    {
      ...info.userData,
    },
    {
      headers: {
        Authorization: token,
        'Content-Type': 'multipart/form-data',
      },
    },
  );

  return data.data as any;
};
